// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmationModal_container__mcXKJ"};